import React, { useEffect } from 'react';
import '../../assets/customCss/myBootstrap.css'
import { useSelector, useDispatch } from 'react-redux';
import { fetchHomes, selectAllHomes, setHomes, getItemsStatus, getItemsError, selectMainHomes, selectPilar3Homes } from './homesSlice';
import HomeAuthor from './HomeAuthor';
import TimeAgo from './TimeAgo';
//import ReactionButtons from './ReactionButtons';
import { FaSpinner } from 'react-icons/fa'
//import Iframe from '../../components/contentElements/Iframe';
import Blockquote from '../../components/contentElements/Blockquote';
//import Slider from '../../components/contentElements/Slider';
import SingleSlide from '../../components/contentElements/SingleSlide';



const HomesPilar3List = () => {
  const homes = useSelector(selectMainHomes);
  console.log(homes);
  const itemStatus = useSelector(getItemsStatus);
  const error = useSelector(getItemsError);

  const selectedItems = homes.filter((home) => home.pilar_name === 'Production');
  console.log('from Pilar3 list', selectedItems)
    
  Object.values(selectedItems).sort((a, b) => a.id - b.id);

  let content;
  if(itemStatus === 'loading') {
    content = <p>Loading...</p>
  } else if(itemStatus === 'succeeded') {

    content = (
      <article id='presentation'> 
      {selectedItems.map((home) => (
        <React.Fragment key={`pilar3list-${home.id}`}>
          <h3><FaSpinner /> {home.title}</h3>
          <small>
            <HomeAuthor userId={home.userId}/>  
            <TimeAgo timestamp={home.date}/>
          </small>
          <p>
            {home.content}
          </p>
          {/* <ReactionButtons home={home}/> */}
        </React.Fragment>
      ))}
    </article>  
   );
  }else if(itemStatus === 'failed'){
    content = <p>{error}</p>
  }else {
    content = null; // Handle other cases if needed
  }
   
  return (
    <section>
      <SingleSlide />
      <Blockquote />
      {content}
    </section>
  )
}

export default HomesPilar3List